import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_ALLOW_INDIVIDUAL_SHIFT_TIMES } from './allow-individual-shift-times.gql';

export function AllowIndividualShiftTimes() {
  const [queryAllowIndividualShiftTimes] = useCampfireLazyQuery<any, {}>(GET_ALLOW_INDIVIDUAL_SHIFT_TIMES);
  const [enabled, setEnabled] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    queryAllowIndividualShiftTimes({}).then((response) =>
      setEnabled(response.data?.vm.configItem?.defaultValue || response.data?.vm.configItem?.configItemValue?.flagValue)
    );
  }, []);

  const saveFetch = useCampfireFetch({ defer: true });
  const apiUrl = useApiUrl();

  const onSave = () => {
    saveFetch
      .run({
        url: `${apiUrl}/vm/admin-console/operations/config-item`,
        method: 'post',
        data: {
          key: 'allow-individual-shift-times',
          value: !enabled,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setEnabled(!enabled);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(enabled)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'individual shift times toggle' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            Individual Shift Times
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            Allow setting individual start and end times for each volunteer on a roster, rather than using the shared
            session times.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
